module.exports = __webpack_public_path__ + "static/img/platform-openrecord.b00b2c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/platform/platform-openrecord.png
// module id = v0fj
// module chunks = 0